import { Action } from '@ngrx/store';
import { LoginResponseInterface } from '../../models/login-response.interface';

export enum ERefreshTokenActions {
  RefreshToken = '[REFRESH_TOKEN] Refresh token',
  RefreshTokenSuccess = '[REFRESH_TOKEN] Refresh token success',
  RefreshTokenFailure = '[REFRESH_TOKEN] Refresh token failure'
}

export class RefreshToken implements Action {
  public readonly type = ERefreshTokenActions.RefreshToken;
}

export class RefreshTokenSuccess implements Action {
  public readonly type = ERefreshTokenActions.RefreshTokenSuccess;
  constructor(public payload: LoginResponseInterface) {}
}

export class RefreshTokenFailure implements Action {
  public readonly type = ERefreshTokenActions.RefreshTokenFailure;
}

export type RefreshTokenActions = RefreshToken | RefreshTokenSuccess | RefreshTokenFailure;
